import { CommentData } from "./Comment";
import { Media } from "./Media";

export class Card {
    cardOwnerName:any;
    cardId:any;
    cardTitle:any;
    cardDesc:any;
    cardRating:number=0;
    cardComment:CommentData[]=[];
    cardLike:boolean;
    cardLikeCount:number=5
    cardCreatedDate:Date;
    headerColour:any;
    cardProfileImg:any;
    fileCount:number;
    sectionId:any;
    userId:any;
    boardId:any;
    cardExpandFlag:boolean=false;
    comments_count:number;
    media:Media[];
    commentText:any;
    user_info:[];
    showReaction:boolean=false;
    showReactionEdit:boolean=false;
    reactions:[];
    reactionCount:number;
    lastThreeReaction=[];
    reactionBag="";
    reactionIconClass="";
    thumbnail:any
    sdg_tags=[];
    cardAnimationClass=""


    

}